import { render, staticRenderFns } from "./Lives.vue?vue&type=template&id=cffb8322&scoped=true&"
import script from "./Lives.vue?vue&type=script&lang=ts&"
export * from "./Lives.vue?vue&type=script&lang=ts&"
import style0 from "./Lives.vue?vue&type=style&index=0&id=cffb8322&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffb8322",
  null
  
)

export default component.exports